import { DocumentGrid } from './DocumentGrid';
import { VORGANG_SOLL, DAUER_SOLL, VORGANG_CATEGORIES, DAUER_CATEGORIES } from './documentSets';

/** Zwei Spalten nebeneinander: links Vorgang-Dokumente, rechts Dauer-Dokumente.
 *  Nur noch im Bericht-Editor verwendet. */
export function DocumentArea({ vorgangId, customerId, refreshKey, customerEmail }: { vorgangId: number; customerId: number; refreshKey?: number; customerEmail?: string | null }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-x-6 gap-y-4">
      <div className="md:col-span-3 min-w-0">
        <DocumentGrid title="Vorgang-Dokumente" level={{ vorgangId }} soll={VORGANG_SOLL} categories={VORGANG_CATEGORIES} refreshKey={refreshKey} />
      </div>
      <div className="md:col-span-2 min-w-0 md:border-l border-slate-200 dark:border-slate-700 md:pl-6">
        <DocumentGrid title="Dauer-Dokumente" level={{ customerId }} soll={DAUER_SOLL} categories={DAUER_CATEGORIES} refreshKey={refreshKey} customerEmail={customerEmail} />
      </div>
    </div>
  );
}
